module.exports = __webpack_public_path__ + "img/coin_grab.f314d7a8.png";